
// export const myGetter = ( state ) => {
//  return state
// }

export const racksList = state => state.racks
export const racksSelectable = state => state.racksSelectable
export const racksPaginatedData = state => state.racksPaginatedData
export const rack = state => state.rack
export const isLoading = state => state.isLoading
export const isCreating = state => state.isCreating
export const isUpdating = state => state.isUpdating
export const createdData = state => state.createdData
export const updatedData = state => state.updatedData
export const isDeleting = state => state.isDeleting
export const deletedData = state => state.deletedData